import {
  READ_PLAN_EVENTS_LIST,
  READ_PLAN_EVENTS_LIST_SUCCEEDED,
  READ_PLAN_EVENTS_LIST_FAILED,
} from "./types"

export const readPlanEventList = config => {
  return { type: READ_PLAN_EVENTS_LIST, config }
}

export const readPlanEventListSuccess = (action, response) => {
  return { type: READ_PLAN_EVENTS_LIST_SUCCEEDED, action, response }
}

export const readPlanEventListError = (action, error) => {
  return { type: READ_PLAN_EVENTS_LIST_FAILED, action, error }
}
